// Legacy dark-mode toggle has been removed.
// V2 uses its own theme picker (see hooks/useScheduleTheme.js and
// components/v2/V2ThemePicker.js) which sets `data-theme` on the v2 root.
//
// initializeTheme is kept as a defensive no-op that scrubs any stale
// `dark-mode`/`dark` classes from documents that were saved before the
// dark-mode feature was removed. It can be deleted once all known
// browsers have refreshed at least once.

export const initializeTheme = () => {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.remove('dark');
  document.body.classList.remove('dark-mode');
  try {
    localStorage.removeItem('theme');
  } catch (_) {
    // ignore
  }
};

// Time-based theme colors (still used by other code paths)
export const getTimeColor = (hour) => {
  if (hour >= 0 && hour < 6) return 'night';
  if (hour >= 6 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 18) return 'afternoon';
  return 'evening';
};

export const getTimeGradient = (hour) => {
  const timeOfDay = getTimeColor(hour);
  const gradients = {
    night: 'linear-gradient(135deg, hsl(234 89% 46%) 0%, hsl(234 89% 36%) 100%)',
    morning: 'linear-gradient(135deg, hsl(199 89% 48%) 0%, hsl(199 89% 58%) 100%)',
    afternoon: 'linear-gradient(135deg, hsl(38 92% 50%) 0%, hsl(38 92% 60%) 100%)',
    evening: 'linear-gradient(135deg, hsl(262 83% 58%) 0%, hsl(262 83% 48%) 100%)',
  };
  return gradients[timeOfDay];
};

// Color utilities
export const colors = {
  // Get HSL color value
  getHSL: (colorVar) => {
    if (typeof window === 'undefined') return '';
    const root = document.documentElement;
    const value = getComputedStyle(root).getPropertyValue(colorVar).trim();
    return value ? `hsl(${value})` : '';
  },

  // Get RGB color value
  getRGB: (colorVar) => {
    if (typeof window === 'undefined') return '';
    const hsl = colors.getHSL(colorVar);
    if (!hsl) return '';

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = hsl;
    const rgb = ctx.fillStyle;
    return rgb;
  },

  // Generate color shades
  generateShades: (baseColor, shades = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900]) => {
    const output = {};
    shades.forEach(shade => {
      output[shade] = `var(--${baseColor}-${shade})`;
    });
    return output;
  },
};
